import { useTheme } from '@emotion/react'
import React from 'react'
import { Joyride, EventData, Step } from 'react-joyride'
import { joyrideLocales } from './locales'
import GuideModal from '../GuideModal'

interface IProps {
  steps: Step[]
  disableScrolling?: boolean
  onEvent: (data: EventData) => void
}

const beaconSize = 50

const JoyrideDefault: React.FC<IProps> = ({
  steps,
  disableScrolling = false,
  onEvent,
}) => {
  const theme = useTheme()
  return (
    <Joyride
      run={!!steps}
      debug={false}
      steps={steps}
      continuous={true}
      tooltipComponent={GuideModal}
      scrollToFirstStep
      onEvent={onEvent}
      floatingOptions={{
        beaconOptions: {
          offset: -beaconSize,
        },
      }}
      styles={{
        beacon: {
          height: beaconSize,
          width: beaconSize,
        },

        beaconInner: {
          backgroundColor: theme.primary,
          border: `2px solid ${theme.primary}`,
        },

        beaconOuter: {
          backgroundColor: theme.illustrationPrimary40,
          border: `2px solid ${theme.primary}`,
        },

        overlay: {
          zIndex: 1001,
        },

        spotlight: {
          style: {
            filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.25))',
          },
        },

        tooltip: {
          zIndex: 1002,
        },
      }}
      locale={joyrideLocales}
      options={{
        skipScroll: disableScrolling,
        scrollOffset: 300,
        scrollDuration: 200,
        overlayClickAction: false,
        zIndex: 1001,
        buttons: ['close', 'primary'],
      }}
    />
  )
}

export default JoyrideDefault
